import { render, staticRenderFns } from "./ClassifiedListing.vue?vue&type=template&id=27ffdbbf&scoped=true&"
import script from "./ClassifiedListing.vue?vue&type=script&lang=js&"
export * from "./ClassifiedListing.vue?vue&type=script&lang=js&"
import style0 from "./ClassifiedListing.vue?vue&type=style&index=0&id=27ffdbbf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ffdbbf",
  null
  
)

export default component.exports